/**
 * Interop shim for @twa-dev/sdk.
 *
 * The package ships CJS (`exports.default = WebApp` with `__esModule: true`).
 * rolldown-vite's dep optimizer exports the raw CJS exports object as the
 * default export, so `import WebApp from '@twa-dev/sdk'` yields
 * `{ default: WebApp }` and every `WebApp.*` access crashes.
 *
 * vite.config.ts aliases the bare specifier '@twa-dev/sdk' to this file,
 * which unwraps the nested default when present. The deep import below does
 * not match the exact-match alias, so there is no recursion.
 */
// @ts-expect-error -- '@twa-dev-sdk-cjs' is a vite alias to the package's
// CJS entry file (its exports map forbids the deep import)
import pkg from '@twa-dev-sdk-cjs'

type WebAppType = typeof import('@twa-dev/sdk').default

const WebApp: WebAppType =
    (pkg as unknown as { default?: WebAppType }).default ??
    (pkg as unknown as WebAppType)

export default WebApp
